import React, { useReducer, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useLocation } from "react-router-dom";

import { AttemptUserLoginFlow, sessionUsername } from '../Core/LoginManager'
import { AttemptAdminPortalLoginFlow, isAdminUser } from '../Core/AdminLoginManager'
import AdminPortal from '../Admin/AdminPortal';
import PageContainerWithLogo from '../Core/PageContainerWithLogo';

export default function AdminRouter()
{
  const [ , forceUpdate ] = useReducer( x => x + 1, 0 );
  const adminLoginAttempted = useRef( false );

  useEffect( () =>
  {
    if( sessionUsername && isAdminUser === undefined && !adminLoginAttempted.current )
    {
      adminLoginAttempted.current = true;

      AttemptAdminPortalLoginFlow( ( loginResponseData ) =>
      {
        console.log( "AdminRouter :: logging in ADMIN user...", loginResponseData );
        forceUpdate();
      } );
    }
  }, [ sessionUsername, isAdminUser ] );

  if( !sessionUsername )
  {
    // User hasn't logged in yet; must've opened up a fresh browser tab with this room URL
    // Need to log them in first

    AttemptUserLoginFlow( () =>
    {
      forceUpdate();
    }, null ); // No connection error handler for admin router
  }
  else if( isAdminUser === undefined )
  {
    // Admin login attempt is handled in useEffect
  }
  else
  {
    if( isAdminUser )
    {
      return (
        <PageContainerWithLogo>
          <AdminPortal />
        </PageContainerWithLogo>
      );
    }
    else
    {
      return (
        <PageContainerWithLogo>
          <div>Access Denied</div>
        </PageContainerWithLogo>
      );
    }
  }

  return (
    <PageContainerWithLogo>
      <div>Attempting to access admin portal...</div>
    </PageContainerWithLogo>
  );
}
